import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';
import { quizPlacementDataDefault } from 'utils/valueDefault';

const apiUrl = `${API_URL}/quiz_placement`;

export const ACTION_TYPES = {
  FETCH_QUIZPLACEMENT_LIST: 'quizplacement/FETCH_QUIZPLACEMENT_LIST',
  FETCH_QUIZPLACEMENT: 'quizplacement/FETCH_QUIZPLACEMENT',
  CREATE_QUIZPLACEMENT: 'quizplacement/CREATE_QUIZPLACEMENT',
  UPDATE_QUIZPLACEMENT: 'quizplacement/UPDATE_QUIZPLACEMENT',
  DELETE_QUIZPLACEMENT: 'quizplacement/DELETE_QUIZPLACEMENT',
  RESET: 'quizplacement/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [], //ent
  entity: quizPlacementDataDefault, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const quizPlacementReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_QUIZPLACEMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_QUIZPLACEMENT):
    case REQUEST(ACTION_TYPES.UPDATE_QUIZPLACEMENT):
    case REQUEST(ACTION_TYPES.DELETE_QUIZPLACEMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_QUIZPLACEMENT):
    case FAILURE(ACTION_TYPES.CREATE_QUIZPLACEMENT):
    case FAILURE(ACTION_TYPES.UPDATE_QUIZPLACEMENT):
    case FAILURE(ACTION_TYPES.DELETE_QUIZPLACEMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_QUIZPLACEMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_QUIZPLACEMENT):
    case SUCCESS(ACTION_TYPES.UPDATE_QUIZPLACEMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_QUIZPLACEMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default quizPlacementReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getQuizPlacementEntitiesByCourseId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST,
  payload: axios.get(`${apiUrl}/course/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getQuizPlacementEntitiesByCourseIdParams = (id, page, size, sort, classId, unitId, batchYear) => ({
  type: ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST,
  payload: axios.get(`${apiUrl}/course/${id}/param`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
      classId: undefined || classId,
      unitId: undefined || unitId,
      batchYear: undefined || batchYear,
    },
  }),
});

export const getQuizPlacementEntitiesByClassId = (id, page, size) => ({
  type: ACTION_TYPES.FETCH_QUIZPLACEMENT_LIST,
  payload: axios.get(`${apiUrl}/classroom/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      // sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_QUIZPLACEMENT,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = (entity, idcourse) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_QUIZPLACEMENT,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getQuizPlacementEntitiesByCourseId(idcourse, null, null, 'createdDate,asc'));
  return result;
};

export const updateEntity = (entity, id, idcourse, pagination, sort, unitPick, yearPick, classPick) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_QUIZPLACEMENT,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  if(classPick === "" && yearPick === "" && unitPick === ""){
    dispatch(getQuizPlacementEntitiesByCourseId(idcourse, pagination.current-1, null, sort));
  }else{
    if(classPick === "") {
      classPick = null;
    }

    if(yearPick === "") {
      yearPick = null;
    }

    if(unitPick === "") {
      unitPick = null;
    }
    dispatch(getQuizPlacementEntitiesByCourseIdParams(idcourse, pagination.current-1, null, sort, classPick, unitPick, yearPick));
  }
  
  return result;
};

export const deleteEntity = (id, id2, pagination, sort, classPick, unitPick, yearPick) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_QUIZPLACEMENT,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  if(classPick === "" && yearPick === "" && unitPick === ""){
    dispatch(getQuizPlacementEntitiesByCourseId(id2, pagination.current-1, null, sort));
  }else{
    if(classPick === "") {
      classPick = null;
    }

    if(yearPick === "") {
      yearPick = null;
    }

    if(unitPick === "") {
      unitPick = null;
    }
    dispatch(getQuizPlacementEntitiesByCourseIdParams(id2, pagination.current-1, null, sort, classPick, unitPick, yearPick));
  }
  
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
